export var SituationType;
(function (SituationType) {
    SituationType["OPEN"] = "1";
    SituationType["PAID"] = "2";
    SituationType["CANCELED"] = "3";
    SituationType["TITLE_TRANSFERRED"] = "5";
    SituationType["LATE"] = "7";
})(SituationType || (SituationType = {}));
export var StatusGroup;
(function (StatusGroup) {
    StatusGroup["PAYABLE"] = "1";
    StatusGroup["PAID"] = "2";
})(StatusGroup || (StatusGroup = {}));
//# sourceMappingURL=card-payment-type.js.map